import { NextRequest } from 'next/server';
import { ActiveExperiments, COOKIES_CONFIG, Experiment } from '@belong/common';
import { BelongExperiment, VariantKey } from './belong-experiment';

const { EXPERIMENTS } = COOKIES_CONFIG;

export function getVariant(unit: string, experiment: Experiment) {
  const { name, salt } = experiment;
  const choices = experiment.variations.map((variation) => variation.value);
  const weights = experiment.variations.map((variation) => variation.weight);
  const belongExperiment = new BelongExperiment({
    name,
    salt,
    unit,
    choices,
    weights,
  });
  return belongExperiment.get(VariantKey, null);
}

export function parseExperimentCookieMiddleware(
  req: NextRequest,
  trackingId: string,
) {
  const existingExperiments = req.cookies.get(EXPERIMENTS.name)?.value || '{}';
  let parsedExperiments: Record<string, string> = {};
  try {
    parsedExperiments = JSON.parse(existingExperiments);
  } catch {}

  try {
    const newExperiments: Record<string, string> = {};
    ActiveExperiments.forEach((experiment) => {
      const { name, condition } = experiment;
      if (parsedExperiments[name]) return;
      if (condition && !condition(req)) return;

      newExperiments[experiment.name] = getVariant(trackingId, experiment);
    });

    parsedExperiments = { ...parsedExperiments, ...newExperiments };
  } catch (e) {
    console.error('AB TESTING MIDDLEWARE ERROR', e);
  }

  return parsedExperiments;
}
